module.exports = __webpack_public_path__ + "static/media/poppy-staff-web-hubton.5de33d0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/poppy-staff-web-hubton.png
// module id = 182
// module chunks = 0